import { Link, Stack, Typography } from "@mui/material";
import Chip from "@mui/material/Chip";
import Grid from "@mui/material/Grid";
import CurrencyFigure from "components/displays/currencyFigure";
import DetailListVertical from "components/displays/detailListVertical";
import IBuyPaper from "components/displays/iBuyPaper";
import { INVOICE_SUMMARY_PAGE, PO_SUMMARY_PAGE } from "constants/routes";
import PropTypes from "prop-types";
import React from "react";
import { useNavigate } from "react-router";
import { setShowInvoiceSummaryDialogue } from "redux/actions/generalActions";

const convertOU = {
    105: "SSE",
    121: "GEN",
    1256: "IRE",
    203: "RENUK",
    4461: "GENIRE",
    23259: "EGL2",
    23260: "EGL3",
    23983: "DST",
};

const InvoiceSearchCard = ({ invoice, dispatch, isPoSummary }) => {
    const navigate = useNavigate();
    return (
        <IBuyPaper>
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <Stack direction="row" justifyContent="space-between">
                        <Link
                            underline="always"
                            component="button"
                            color="secondary"
                            onClick={() => {
                                navigate(
                                    INVOICE_SUMMARY_PAGE(invoice?.INVOICE_ID)
                                );
                                dispatch(setShowInvoiceSummaryDialogue(false));
                            }}
                        >
                            <Typography
                                component="h2"
                                variant="h5"
                                color="text.subheader"
                            >
                                {invoice?.INVOICE_ID}
                            </Typography>
                        </Link>

                        <Chip
                            label={
                                convertOU[invoice?.ORG_ID] ?? invoice?.ORG_ID
                            }
                            color="secondary"
                        />
                    </Stack>
                </Grid>

                <Grid item xs={12} container spacing={1}>
                    <Grid item xs>
                        <DetailListVertical
                            condensed={true}
                            details={[
                                {
                                    header: "Invoice Number",
                                    content: invoice?.INVOICE_NUM,
                                },
                                {
                                    header: "Invoice Date",
                                    content: invoice?.INVOICE_DATE,
                                },
                                {
                                    header: "Invoice Amount",
                                    content: (
                                        <CurrencyFigure
                                            value={invoice?.INVOICE_AMOUNT}
                                            code={
                                                invoice?.INVOICE_CURRENCY_CODE
                                            }
                                        />
                                    ),
                                },
                                {
                                    header: "Invoice Type",
                                    content: invoice?.INVOICE_TYPE_DISP,
                                },
                                {
                                    header: "Supplier Name",
                                    content: invoice?.SUPPLIER_NAME,
                                },
                                {
                                    header: "Supplier Site",
                                    content: invoice?.SUPPLIER_SITE_CODE,
                                },
                                isPoSummary && {
                                    header: "On Hold",
                                    content: invoice?.ON_HOLD ? "Y" : "N",
                                },
                                !isPoSummary && {
                                    header: "PO Number",
                                    content: invoice?.PO_NUMBER ? (
                                        <Link
                                            underline="always"
                                            component="button"
                                            color="secondary"
                                            onClick={() => {
                                                navigate(
                                                    PO_SUMMARY_PAGE(
                                                        invoice?.PO_NUMBER
                                                    )
                                                );
                                                dispatch(
                                                    setShowInvoiceSummaryDialogue(
                                                        false
                                                    )
                                                );
                                            }}
                                        >
                                            <Chip
                                                label={invoice?.PO_NUMBER}
                                                size="small"
                                                sx={{ cursor: "pointer" }}
                                                variant="outlined"
                                                color="info"
                                            />
                                        </Link>
                                    ) : (
                                        "N/A"
                                    ),
                                },
                            ]}
                        />
                    </Grid>
                </Grid>
            </Grid>
        </IBuyPaper>
    );
};

InvoiceSearchCard.propTypes = {
    invoice: PropTypes.object,
    dispatch: PropTypes.func,
    isPoSummary: PropTypes.bool,
};

export default InvoiceSearchCard;
